import { chakra, EloInputSearch, Menu, Skeleton } from '@plurall/elo-v3';

import {
  PerformanceDashboardActionsContentRecipe,
  PerformanceDashboardActionsItemRecipe,
  PerformanceDashboardActionsTriggerRecipe,
  PerformanceDashboardFilterSelectRecipe,
  PerformanceDashboardFiltersFormRecipe,
  PerformanceDashboardFiltersRowRecipe,
  PerformanceDashboardHeaderActionsRecipe,
  PerformanceDashboardHeaderContentRecipe,
  PerformanceDashboardHeaderFilterGroupRecipe,
  PerformanceDashboardHeaderFilterLabelRecipe,
  PerformanceDashboardHeaderRootRecipe,
  PerformanceDashboardHeaderRowRecipe,
  PerformanceDashboardHeaderSubtitleRecipe,
  PerformanceDashboardHeaderTitleGroupRecipe,
  PerformanceDashboardHeaderTitleRecipe,
  PerformanceDashboardMetricRecipe,
  PerformanceDashboardMetricWithSeparatorRecipe,
  PerformanceDashboardMobileActionsItemRecipe,
  PerformanceDashboardMobileActionsListRecipe,
  PerformanceDashboardResultsMetricsRecipe,
  PerformanceDashboardResultsRecipe,
  PerformanceDashboardResultsSkeletonItemRecipe,
  PerformanceDashboardResultsSkeletonListRecipe,
  PerformanceDashboardResultsSkeletonMediumWrapperRecipe,
  PerformanceDashboardResultsSkeletonRecipe,
  PerformanceDashboardResultsSkeletonSmallWrapperRecipe,
  PerformanceDashboardResultsTitleRecipe,
  PerformanceDashboardSearchButtonWrapperRecipe,
  PerformanceDashboardSearchDropdownRecipe,
  PerformanceDashboardYearGroupRecipe,
} from './PerformanceDashboardHeader.recipe';

export const PerformanceDashboardHeaderRootFactory = chakra('header', PerformanceDashboardHeaderRootRecipe);
export const PerformanceDashboardHeaderRowFactory = chakra('div', PerformanceDashboardHeaderRowRecipe);
export const PerformanceDashboardHeaderTitleGroupFactory = chakra('div', PerformanceDashboardHeaderTitleGroupRecipe);
export const PerformanceDashboardHeaderTitleFactory = chakra('h1', PerformanceDashboardHeaderTitleRecipe);
export const PerformanceDashboardHeaderContentFactory = chakra('div', PerformanceDashboardHeaderContentRecipe);
export const PerformanceDashboardHeaderSubtitleFactory = chakra('p', PerformanceDashboardHeaderSubtitleRecipe);
export const PerformanceDashboardHeaderActionsFactory = chakra('div', PerformanceDashboardHeaderActionsRecipe);
export const PerformanceDashboardHeaderFilterGroupFactory = chakra('div', PerformanceDashboardHeaderFilterGroupRecipe);
export const PerformanceDashboardHeaderFilterLabelFactory = chakra(
  'label',
  PerformanceDashboardHeaderFilterLabelRecipe
);
export const PerformanceDashboardYearGroupFactory = chakra('div', PerformanceDashboardYearGroupRecipe);
export const PerformanceDashboardActionsTriggerFactory = chakra('button', PerformanceDashboardActionsTriggerRecipe);
export const PerformanceDashboardActionsContentFactory = chakra(Menu.Content, PerformanceDashboardActionsContentRecipe);
export const PerformanceDashboardActionsItemFactory = chakra(Menu.Item, PerformanceDashboardActionsItemRecipe);
export const PerformanceDashboardMobileActionsListFactory = chakra('div', PerformanceDashboardMobileActionsListRecipe);
export const PerformanceDashboardMobileActionsItemFactory = chakra(
  'button',
  PerformanceDashboardMobileActionsItemRecipe
);
export const PerformanceDashboardFiltersFormFactory = chakra('form', PerformanceDashboardFiltersFormRecipe);
export const PerformanceDashboardFiltersRowFactory = chakra('div', PerformanceDashboardFiltersRowRecipe);
export const PerformanceDashboardFilterSelectFactory = chakra('div', PerformanceDashboardFilterSelectRecipe);
export const PerformanceDashboardResultsFactory = chakra('section', PerformanceDashboardResultsRecipe);
export const PerformanceDashboardResultsSkeletonFactory = chakra('div', PerformanceDashboardResultsSkeletonRecipe);
export const PerformanceDashboardResultsSkeletonSmallWrapperFactory = chakra(
  'div',
  PerformanceDashboardResultsSkeletonSmallWrapperRecipe
);
export const PerformanceDashboardResultsSkeletonMediumWrapperFactory = chakra(
  'div',
  PerformanceDashboardResultsSkeletonMediumWrapperRecipe
);

export const PerformanceDashboardResultsSkeletonListFactory = chakra(
  'div',
  PerformanceDashboardResultsSkeletonListRecipe
);
export const PerformanceDashboardResultsSkeletonItemFactory = chakra(
  Skeleton,
  PerformanceDashboardResultsSkeletonItemRecipe
);
export const PerformanceDashboardResultsTitleFactory = chakra('h2', PerformanceDashboardResultsTitleRecipe);
export const PerformanceDashboardResultsMetricsFactory = chakra('div', PerformanceDashboardResultsMetricsRecipe);
export const PerformanceDashboardMetricFactory = chakra('span', PerformanceDashboardMetricRecipe);
export const PerformanceDashboardMetricWithSeparatorFactory = chakra(
  'span',
  PerformanceDashboardMetricWithSeparatorRecipe
);
export const PerformanceDashboardSearchButtonWrapperFactory = chakra(
  'div',
  PerformanceDashboardSearchButtonWrapperRecipe
);
export const PerformanceDashboardSearchDropdownFactory = chakra(
  EloInputSearch.Content,
  PerformanceDashboardSearchDropdownRecipe
);
